export default __webpack_public_path__ + "static/media/welcome-client-experience.d807cc1b.png";